import Section from "../../modules/section/Section";
import ContactForm from "../../modules/contactForm/ContactForm";
import { useTranslation } from "react-i18next";
import Map from "components/modules/map/Map";

const Contact = () => {
  const { t } = useTranslation();

  return (
    <>
      <Section marginBottom>
        <div className={"relative"}>
          <Map />
        </div>
      </Section>
      <Section twoColumn container>
        <address>
          {t("addressLine1")}
          <br />
          {t("addressLine2")}
          <br />
          {t("addressLine3")}
          <br />
          <br />
          +389 2 3230 789
          <br />
          info@dimitrov.com.mk
          <br />
        </address>
        <ContactForm />
      </Section>
    </>
  );
};

export default Contact;
